import { Box } from '@mui/material';
import { styled } from '@mui/system';

const NoScrollBox = styled(Box)(({ theme }) => ({
  height: `calc(100vh - ${theme.spacing(8)} - 1rem )`,
  overflow: 'hidden',
}));

export default NoScrollBox;
